import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Dot } from '@lyearn/ui';

export function getButtonLabel(
  selectedItems: React.ReactNode[],
  defaultLabel: string,
  className?: string,
) {
  if (selectedItems.length === 1) {
    return <Box className={cn('label flex items-center', className)}>{selectedItems[0]}</Box>;
  }

  if (selectedItems.length) {
    return (
      <Box className={cn('label flex items-center', className)}>
        {defaultLabel}
        <Dot background="bg-interactive-primary" />
        {selectedItems.length}
      </Box>
    );
  }

  return <Box className="label flex items-center">{defaultLabel}</Box>;
}
